import _ from 'lodash';

export function usePriceMapper() {
  const typeMap = {
    1: 'cmr',
    2: 'normal',
    3: 'event',
    4: 'normal',
  };

  const getCommonPriceProps = ({ price }) => {
    if (!price) return {};
    return {
      type: typeMap[price.type] || '',
      symbol: price.symbol || '',
      integerValue: price.originalPrice || '0',
      crossed: price.crossed || false,
    };
  };

  const mapPrices = (product) => {
    const cmrPrice = _.find(product.prices, { type: 1 });
    const eventPrice = _.find(product.prices, { type: 3 });
    const basePrice = _.find(product.prices, { type: 2 });

    let combination = '';
    if (cmrPrice) {
      combination = 'cmr';
    } else if (eventPrice) {
      combination = 'internet';
    }

    return {
      ...(basePrice && { base: getCommonPriceProps({ price: basePrice }) }),
      ...(eventPrice && {
        special: {
          ...getCommonPriceProps({ price: eventPrice }),
          ...(!cmrPrice && {
            discountValue: _.get(product, 'discountBadge.label', ''),
          }),
          bold: true,
        },
      }),
      ...(cmrPrice && {
        cmr: {
          ...getCommonPriceProps({ price: cmrPrice }),
          icon: 'cmr',
          discountValue: _.get(product, 'discountBadge.label', ''),
        },
      }),
      meta: { combination },
    };
  };

  return { mapPrices };
}
